import { render, staticRenderFns } from "./AddInBox.vue?vue&type=template&id=6daee62a&"
import script from "./AddInBox.vue?vue&type=script&lang=js&"
export * from "./AddInBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports